/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import Switcher from '/client/src/components/switcher';
import SimpleInput from '/client/src/components/forms/simpleInput';
import Forms from './forms';
import MapTicket from '../design/ticketSections/map';
import CreateEditEventLevels from './levels/';
import Features from './features';
import Loader from '/client/src/components/Loader';
import SaveBtn, { SaveBtnRef } from './saveBtn';
import WithEventContext from './WithEventContext';
import _ from 'lodash';
import SuccessConfetti from './confetti';
import { GET } from '/client/src/api/';

import type { CreateEditStateType } from './types';

import './styles.scss';
import { RouterPrompt } from '../../../../components/routerPrompt';

class CreateEditEvent extends React.Component<CreateEditStateType> {
  props: CreateEditStateType;

  static contextType = DefaultContainerContext;

  constructor(props: CreateEditStateType, context: {}) {
    super(props, context);

    this._isClone = props.match.params.viewTab === 'clone';
    this._isEdit = props.match.params.viewTab === 'edit';
    this._isEditNew = props.match.params.viewTab === 'edit-new';
    this._isNew = props.match.url === '/events/new';

    this.urlNamePrefix = process.env.EVENT_HOST;
    this.state = {
      profileCurrent: context.profileCurrent,
      isShowExtraActions: false,
      urlNameError: false,
      oldUrlName: ''
    };
  }

  handleTabClose = (event: any): string => {
    if (!_.isEqual(this.props.summaryEventData(), localStorage.getItem('initEventData'))) {
      const msg =  'Changes you made may not be saved.';

      event.preventDefault();
      event.returnValue = msg;

      return msg;
    }
  }

  componentDidMount() {
    const ExtraActionsTimeout = setTimeout(() => {
      this.setState({
        isShowExtraActions: true
      });

      clearTimeout(ExtraActionsTimeout);
    }, 2000);

    if (this._isClone) {
      this.props.handleChangeInput({
        target: {
          name: 'name',
          value: `${this.props.name}-copy`
        }
      });

      this.props.handleChangeInput({
        target: {
          name: 'url_name',
          value: `${this.props.url_name.substring(this.urlNamePrefix.length)}-copy`
        }
      });
    }

    this.setState({
      oldUrlName: this.props.url_name
    });

    window.addEventListener('beforeunload', this.handleTabClose);

    return () => {
      window.removeEventListener('beforeunload', this.handleTabClose);
    };
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleTabClose);
  }

  toggleLockSaveBtn = (status: boolean) => {
    const btn = SaveBtnRef.current;

    if (status) {
      btn.classList.add('isLock');
    } else {
      btn.classList.remove('isLock');
    }
  };

  handleCheckUrlName = async (urlName: string) => {
    const { result: {
      is_available
    } } = await GET(decodeURIComponent(`/api/v1/1/events/check_url_name?url_name=${urlName}`));

    this.setState({
      urlNameError: !is_available ? 'This url name already exists' : null
    });

    this.toggleLockSaveBtn(!is_available);
  };

  handleUrlNameValue = (urlName: string): string => {
    const _value = urlName.trim()
    .substring(this.urlNamePrefix.length)
    .replace(/( )/g, '-')
    .replace(/(\/)/g, '-')
    .replace(/(\.)/g, '-')
    .replace(/(\,)/g, '-');

    if (_value.length >= 5) {
      const oldUrlName = this.state.oldUrlName.substring(this.urlNamePrefix.length);

      if (oldUrlName !== _value) {
        this.handleCheckUrlName(_value);
      }

      this.setState({
        urlNameError: null
      });
    } else {
      this.setState({
        urlNameError: 'Please enter at least 5 characters.'
      });
    }

    if (_value.length === 0) {
      this.setState({
        urlNameError: 'This field is required.'
      });
    }
    return _value;
  }

  handleEventBeginTimeChange = (date: string) => {
    this.props.handleChangeDate(date, 'begin_time_utc');
  };

  handleEventEndTimeChange = (date: string) => {
    this.props.handleChangeDate(date, 'end_time_utc');
  }

  componentDidUpdate(prevProps: Props): * {
    if (prevProps.url_name.length > this.urlNamePrefix.length && prevProps.url_name !== this.props.url_name) {
      this.handleUrlNameValue(this.props.url_name);
    }
  }

  render(): React.Element<'div'> {
    const {
      onHandleChangeStepNavBar,
      successSave,
      openedCropModal,
      baseImage,
      croppedImage,
      eventDetailAdvSetStatus,
      lat,
      lng,
      map_zoom,
      name,
      begin_time_utc,
      end_time_utc,
      current_inventory,
      url_name,
      schedules,
      long_description,
      autoCompleteValue,
      suggestions,
      time_zone_id,
      tickets,
      imgUrl,
      skip_event_landing_page,
      show_promotion_tickets,
      show_event_time_and_date,
      show_ticket_sales_time_count_down,
      show_remaining_ticket_count,
      show_tickets,
      skip_collect_attendee_information,
      need_collect_zip_code,
      need_collect_phone_number,
      is_set_tickets_total_capacity,
      tickets_total_capacity,
      share_promotion_setting,
      is_set_conversion_tracking_code,
      facebook_conversion_tracking_code,
      purchased_notification_emails,
      sold_out_notification_emails,
      is_set_notification_email,
      is_set_terms_and_conditions,
      terms_and_conditions,
      is_set_confirm_email,
      confirmation_email_greeting,
      confirmation_email_support_email,
      confirmation_email_support_phone,
      is_confirmation_email_include_tickets,
      is_send_email_reminders,
      is_set_social_promotions,
      facebook_page,
      is_set_addtional_info,
      is_set_donations,
      questions,
      donations,
      eventId,
      match,
      handleLoaded,
      setOpenedCropModal,
      handleSetImages,
      setImageCropInfo,
      setBaseImage,
      setCroppedImage,
      handleChangeCheckbox,
      handleChangeInput,
      handleChangeSearchInput,
      handleChangeSearchInputValue,
      handleSave,
      handleControlTicketLevels,
      need_collect_demographic_data,
      need_collect_full_birth_day,
      handleControlEventQuestion,
      handleControlEventDonations,
      handleControlDonationsEnabled,
      handleControlEventDemographic,
      handleControlEventAdditionalInfo,
      handleControlConversationTrackingCode,
      handleControlNotificationEmail,
      handleControlEventTerms,
      handleControlEmailChecked,
      handleControlFB,
      handleControlGuestShare,
      setValidateDataLength,
      handleControlSocialPromotions,
      image_crop_info,
      permission,
      summaryEventData
    } = this.props;

    const isReadonlyPermission = permission === 'Read';

    const { isShowExtraActions, urlNameError } = this.state;

    if (isReadonlyPermission && !this._isClone) {
      return null;
    }
       if (eventId && !_.size(schedules)) {
      return null;
    }

    const scheduleId = _.find(schedules, (i: {}): {} => _.toString(i.event_id) === _.toString(eventId));
    const Event = (
      <>
        <RouterPrompt
          when={!_.isEqual(summaryEventData(), localStorage.getItem('initEventData'))}
          title="Looks like there were some changes to the event. Save them?"
          onOK={
          async (): any => await handleSave(
            this._isNew || this._isClone,
            this.state.profileCurrent,
            onHandleChangeStepNavBar,
            this._isClone,
            this._isEditNew
          ).then((result: boolean): boolean => result)
        }
          onCancel={(): boolean => true}
        />

        <form
          className='event-edit-form CreateEditEvent'
          onSubmit={(e: any) => {
            e.preventDefault();
          }}
        >
          <div className="panel panel-default panel-page no-border">
            <div className="panel-heading panel-heading-green">
              <div className="panel-title">Event Details</div>
            </div>

            <div className="panel-body">
              <div className="container-fluid">
                <div className="row">

                  <div className="col-md-6 col-lg-6">
                    <SimpleInput
                      validator={{}}
                      name='name'
                      id='name'
                      label='Event Name (required)'
                      value={name}
                      onChange={handleChangeInput}
                      onFocus={(e: any) => {
                        handleChangeInput({
                          target: {
                            name: 'name',
                            value: _.trim(e.target.value)
                          }
                        });
                      }}
                      maxLength={101}
                      isShowLimit
                      limit={100}
                      limitCb={setValidateDataLength}
                    />

                    <SimpleInput
                      validator={{
                        text:  urlNameError
                      }}
                      forceShowValidator={!!urlNameError}
                      name='url_name'
                      id='url_name'
                      label='Event page URL (required)'
                      value={url_name}
                      onChange={(e: any) => {
                        const isProtocolChanged = !e.target.value.startsWith(this.urlNamePrefix);

                        if (isProtocolChanged) return;

                        const _value = this.handleUrlNameValue(e.target.value);

                        handleChangeInput({
                          target: {
                            name: 'url_name',
                            value: _value
                          }
                        });
                      }}
                      maxLength={51}
                      isShowLimit
                      limit={50}
                      limitOffset={this.urlNamePrefix.length}
                      limitCb={setValidateDataLength}
                    />

                    <Forms.EventLocation
                      suggestions={suggestions}
                      value={autoCompleteValue}
                      latlng={{ lat, lng }}
                      onChange={handleChangeSearchInput}
                      onChangeOnlyValue={handleChangeSearchInputValue}
                    />

                    <Forms.EventTimeZone
                      value={time_zone_id}
                      onChange={handleChangeInput}
                    />

                    <Forms.EventDates
                      beginTimeUtc={begin_time_utc}
                      endTimeUtc={end_time_utc}
                      onEventBeginTimeChange={this.handleEventBeginTimeChange}
                      onEventEndTimeChange={this.handleEventEndTimeChange}
                    />

                    <Forms.EventDescr
                      value={long_description}
                      onChange={handleChangeInput}
                      setValidateDataLength={setValidateDataLength}
                    />

                    <Forms.EventPicture
                      openedCropModal={openedCropModal}
                      baseImage={baseImage}
                      croppedImage={croppedImage}
                      setOpenedCropModal={setOpenedCropModal}
                      setBaseImage={setBaseImage}
                      setCroppedImage={setCroppedImage}
                      handleSetImages={handleSetImages}
                      setImageCropInfo={setImageCropInfo}
                      imgUrl={imgUrl}
                      image_crop_info={image_crop_info}
                    />
                  </div>

                  <div className="col-md-6 col-lg-6">
                    <MapTicket
                      withoutEdit
                      p={{ lat, lng, map_zoom }}
                    />
                  </div>

                </div>

                <hr />

                <div className="row">
                  <div className="col-md-8 col-lg-6">
                    <Switcher
                      className='form-switcher-sm pull-left'
                      id='eventDetailAdvSetStatus'
                      index={0}
                      checked={eventDetailAdvSetStatus}
                      onCallback={handleChangeCheckbox}
                      label='Enable advanced event settings'
                    />
                  </div>
                </div>

                {eventDetailAdvSetStatus &&
                  <>
                    <hr style={{ marginTop: '1rem' }} />

                    <Forms.EventDetailsAdvSet
                      skipEventLandingPage={skip_event_landing_page}
                      showEventTimeAndDate={show_event_time_and_date}
                      showPromotionTickets={show_promotion_tickets}
                      showTickets={show_tickets}
                      showTicketSalesTimeCountDown={show_ticket_sales_time_count_down}
                      showRemainingTicketCount={show_remaining_ticket_count}
                      skipCollectAttendeeInformation={skip_collect_attendee_information}
                      needCollectZipCode={need_collect_zip_code}
                      needCollectPhoneNumber={need_collect_phone_number}
                      isSetTicketsTotalCapacity={is_set_tickets_total_capacity}
                      onHandleChangeCheckbox={handleChangeCheckbox}
                    />

                    {is_set_tickets_total_capacity &&
                      <SimpleInput
                        name='tickets_total_capacity'
                        id='limit'
                        label='Limit'
                        style={{
                          marginLeft: '3.25rem',
                          width: '150px'
                        }}
                        value={tickets_total_capacity}
                        onChange={handleChangeInput}
                      />
                    }
                  </>
                }
              </div>
            </div>
          </div>

          <CreateEditEventLevels
            handleControlTicketLevels={handleControlTicketLevels}
            tickets={tickets}
            isClone={this._isClone}
            setValidateDataLength={setValidateDataLength}
            begin_time_utc={begin_time_utc}
            end_time_utc={end_time_utc}
            current_inventory={current_inventory}
          />

          {!this._isEdit && !this._isEditNew &&
            <>
              <div className='CreateEditEvent_featureHeader'>
                <h1>You're almost done! &#128512;</h1>

                <button
                  className="btn btn-pink"
                  onClick={() => {
                    handleSave(true, this.state.profileCurrent, onHandleChangeStepNavBar, this._isClone);
                  }}
                >
                  Next step: design event page
                </button>

                <h3>Are you looking for advanced features? Take a look below.</h3>
              </div>
            </>
          }

          <div className="CreateEditEvent_featureBody">
            <Features.Demographic
              need_collect_demographic_data={need_collect_demographic_data}
              need_collect_full_birth_day={need_collect_full_birth_day}
              handleChangeCheckbox={handleChangeCheckbox}
              handleControlEventDemographic={handleControlEventDemographic}
            />
            <Features.Questions
              isSetAddtionalInfo={is_set_addtional_info}
              questions={questions}
              tickets={tickets}
              handleControlEventQuestion={handleControlEventQuestion}
              handleControlEventAdditionalInfo={handleControlEventAdditionalInfo}
            />
            <Features.Donations
              isSetAddtionalInfo={is_set_donations}
              donations={donations}
              tickets={tickets}
              handleControlEventDonations={handleControlEventDonations}
              handleControlDonationsEnabled={handleControlDonationsEnabled}
            />
            <Features.FB
              isSetSocialPromotions={is_set_social_promotions}
              facebookPage={facebook_page}
              imageUrl={imgUrl}
              handleControlFB={handleControlFB}
              handleControlSocialPromotions={handleControlSocialPromotions}
              setValidateDataLength={setValidateDataLength}
            />
            <Features.Email
              isSetConfirmEmail={is_set_confirm_email}
              confirmationEmailGreeting={confirmation_email_greeting}
              confirmationEmailSupportEmail={confirmation_email_support_email}
              confirmationEmailSupportPhone={confirmation_email_support_phone}
              isConfirmationEmailIncludeTickets={is_confirmation_email_include_tickets}
              isSendEmailReminders={is_send_email_reminders}
              handleChangeInput={handleChangeInput}
              handleControlEmailChecked={handleControlEmailChecked}
            />
            <Features.Terms
              isSetTermsAndConditions={is_set_terms_and_conditions}
              termsAndConditions={terms_and_conditions}
              handleChangeInput={handleChangeInput}
              handleControlEventTerms={handleControlEventTerms}
            />
            <Features.EmailNotify
              purchasedNotificationEmails={purchased_notification_emails}
              soldOutNotificationEmails={sold_out_notification_emails}
              isSetNotificationEmail={is_set_notification_email}
              handleChangeInput={handleChangeInput}
              handleControlNotificationEmail={handleControlNotificationEmail}
            />
            <Features.Conversation
              isSetConversionTrackingCode={is_set_conversion_tracking_code}
              facebookConversionTrackingCode={facebook_conversion_tracking_code}
              handleChangeInput={handleChangeInput}
              handleControlConversationTrackingCode={handleControlConversationTrackingCode}
            />
            <Features.Guest
              sharePromotionSetting={share_promotion_setting}
              tickets={tickets}
              handleControlGuestShare={handleControlGuestShare}
            />
          </div>
        </form>

        {!!isShowExtraActions &&
          <SaveBtn
            handleSave={handleSave}
            onHandleChangeStepNavBar={onHandleChangeStepNavBar}
            isNew={this._isNew || this._isClone}
            isClone={this._isClone}
            isEditNew={this._isEditNew}
            text={this._isEdit ? 'Save' : 'Save & Continue'}
            profileCurrent={this.state.profileCurrent}
          />
        }
      </>
    );

    if (eventId && scheduleId) {
      return (
        <Loader
          url={`/api/v1/1/events/${eventId}/tickets_all?scheduleId=${scheduleId.id}&paymentMethod=1`}
          onLoaded={handleLoaded}
        >
          {!_.isNull(tickets) && <>{Event}</>}
        </Loader>
      );
    }

    return (
      <>
        {Event}

        {successSave &&
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }}
          >
            <SuccessConfetti
              tweenDuration={2000}
              onConfettiComplete={this.onConfettiComplete} // eslint-disable-line
            />
          </div>
        }
      </>
    );
  }
}

export default WithEventContext(withRouter(CreateEditEvent));
